import React, { memo } from "react";
import { Breadcrumb, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import CopyToClipboard from "../../../../components/CopyToClipboard";
import { route } from "../../../../history";

type DroppedFilesNavBreadcrumbProps = {
  droppedSourceId: string;
  filename: string;
  className?: string;
  description?: string;
};

const DroppedFilesNavBreadcrumb: React.FC<DroppedFilesNavBreadcrumbProps> = ({
  droppedSourceId,
  filename,
  className,
  description = "This sample is a Dropped File received during Dynamic Analysis of:"
}) => {
  const navigate = useNavigate();
  const navigateToSampleSummary = (sha1: string) => {
    if (!sha1) return;
    navigate(
      route("redirect_samples_details", {
        hash_value: sha1
      })
    );
  };

  return (
    <Breadcrumb
      className={`dropped_files_breadcrumb ${className}`}
      data-testid="dropped_files_breadcrumb_container"
    >
      <OverlayTrigger
        overlay={
          <Tooltip
            id={`dropped-files-breadcrumb-tooltip-${droppedSourceId}`}
            className="dropped_files_breadcrumb__tooltip"
            data-testid="dropped_files_breadcrumb_source_tooltip"
          >
            Browse {droppedSourceId}
          </Tooltip>
        }
        placement="bottom"
      >
        <Breadcrumb.Item
          title={`Browse ${droppedSourceId}`}
          onClick={() => navigateToSampleSummary(droppedSourceId ?? "")}
          data-testid="dropped_files_breadcrumb_source"
        >
          {droppedSourceId}
        </Breadcrumb.Item>
      </OverlayTrigger>

      <OverlayTrigger
        overlay={
          <Tooltip
            id={`dropped-files-breadcrumb-tooltip-${filename}`}
            className="dropped_files_breadcrumb__tooltip"
            data-testid="dropped_files_breadcrumb_filename_tooltip"
          >
            <span className="flex" style={{ width: "100%" }}>
              {description}
              <span
                className="dropped_files_breadcrumb__tooltip_link"
                data-testid="dropped_files_breadcrumb_filename_tooltip_link"
              >
                {droppedSourceId?.slice(0, 12)}...
              </span>
            </span>
          </Tooltip>
        }
        placement="bottom"
      >
        <Breadcrumb.Item data-testid="dropped_files_breadcrumb_filename">
          {filename}
        </Breadcrumb.Item>
      </OverlayTrigger>

      <CopyToClipboard
        value={filename ?? ""}
        containerClassName="ml-1"
        setContainerLineHeight={false}
      />
    </Breadcrumb>
  );
};

export default memo(DroppedFilesNavBreadcrumb);
